import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface IAuraIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const AuraIcon = ({ fill = '#535353', title, id = 'info-icon', size = 147 }: IAuraIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size} className="align-items-center justify-content-center">
            <svg width="100%" height="100%" viewBox="0 0 120 136" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M84.556 130.28C101.594 129.431 108.174 118.725 110.477 112.98C112.779 107.236 116.7 95.0906 118.175 68.3284C119.651 41.5663 119.289 21.6505 111.565 12.0906C103.844 2.5307 77.2667 1.13916 60.0013 1.13916C42.7331 1.13916 16.1591 2.5307 8.43506 12.0906C0.713859 21.6533 0.352059 41.5663 1.8273 68.3284C3.30255 95.0906 7.22345 107.236 9.52607 112.98C11.8287 118.725 18.4084 129.431 35.4466 130.28C52.4849 131.129 67.5178 131.129 84.556 130.28V130.28Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M60.0014 9.92535C67.6188 9.92535 86.8419 10.6378 92.3446 14.3699C96.6021 17.2588 96.7086 20.7209 96.8657 26.3038C97.0228 31.8867 95.5615 48.1371 92.8691 57.8417C90.1766 67.5464 88.3368 69.7311 86.0033 71.5123C83.6698 73.2934 78.3017 75.3668 68.4125 75.6535C63.0753 75.8066 56.9275 75.8066 51.5874 75.6535C41.6983 75.3668 36.3302 73.2934 33.9967 71.5123C31.6632 69.7311 29.8234 67.5491 27.1309 57.8417C24.4384 48.1343 22.9772 31.8839 23.1343 26.3038C23.2913 20.7237 23.3951 17.2588 27.6554 14.3699C33.1609 10.6378 52.384 9.92535 59.9986 9.92535H60.0014Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M60.0013 11.3531C66.825 11.3531 84.0427 11.9765 88.9733 15.241C92.7876 17.7681 92.883 20.7961 93.0232 25.6776C93.1635 30.5591 91.8565 44.7724 89.4445 53.2636C87.0325 61.7547 85.2095 63.4524 83.2939 65.2197C81.2577 67.0955 76.9722 68.5733 67.5374 68.8405C62.7555 68.9769 57.2499 68.9769 52.468 68.8405C43.0332 68.5705 38.7477 67.0955 36.7115 65.2197C34.7959 63.4524 32.9729 61.7547 30.5609 53.2636C28.1489 44.7724 26.8419 30.5619 26.9822 25.6776C27.1224 20.7961 27.2149 17.7653 31.0321 15.241C35.9626 11.9765 53.1832 11.3531 60.0041 11.3531H60.0013Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M60.0015 13.7911C66.1941 13.7911 81.8244 14.3198 86.3007 17.0862C89.7644 19.2292 89.8485 21.798 89.9747 25.9364C90.1009 30.0749 88.9146 42.1257 86.7242 49.3255C84.5337 56.5226 82.879 57.9642 81.1429 59.4615C79.2946 61.0534 75.4046 62.303 66.8392 62.5312C62.4976 62.6481 57.4997 62.6481 53.1581 62.5312C44.5955 62.303 40.7027 61.0506 38.8544 59.4615C37.1155 57.9642 35.4608 56.5226 33.2732 49.3255C31.0827 42.1284 29.8964 30.0777 30.0226 25.9364C30.1488 21.798 30.2357 19.2292 33.6967 17.0862C38.1729 14.3171 53.8032 13.7911 59.9959 13.7911H60.0015Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M56.2825 130.903L56.95 131.566V134.861H63.0529V131.566L63.7232 130.903"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path d="M63.0529 131.605H56.95" stroke={fill} strokeMiterlimit="10" />
                <path
                    d="M106.528 109.101C109.344 99.5634 104.15 89.6577 94.9266 86.9761C85.703 84.2945 75.9429 89.8524 73.1268 99.3901C70.3107 108.928 75.505 118.833 84.7286 121.515C93.9522 124.197 103.712 118.639 106.528 109.101Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M86.5473 119.534C78.9803 117.138 74.7593 108.909 77.0984 100.985C78.5821 95.9589 82.3543 92.2462 86.8726 90.7183"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M93.6207 119.632C99.1683 118.455 103.903 114.372 105.611 108.591C107.896 100.852 103.953 92.7695 96.6918 89.6274L84.2728 89.4715C79.9256 91.2304 76.4001 94.8679 74.9782 99.6854C72.4989 108.079 77.3481 116.877 85.8069 119.337C86.5333 119.548 87.2597 119.704 87.989 119.813"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M94.9976 89.6051L96.8403 90.8491V94.5033C101.855 97.0554 104.461 103.039 102.752 108.822C101.645 112.577 98.9606 115.429 95.6791 116.821C93.2671 117.845 90.5298 118.079 87.8598 117.302C81.5577 115.471 78.0099 108.705 79.9339 102.187C80.4808 100.337 81.4119 98.7058 82.6067 97.3588C83.8015 96.0145 85.2627 94.9542 86.8725 94.2473V90.7155L85.0439 89.4771L94.9976 89.6051V89.6051Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M95.6792 116.824L93.1046 120.333H88.3338L85.7788 116.473"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M35.2735 121.515C44.4971 118.834 49.6914 108.928 46.8753 99.3905C44.0592 89.8528 34.2991 84.2949 25.0755 86.9766C15.852 89.6582 10.6576 99.5639 13.4737 109.102C16.2898 118.639 26.0499 124.197 35.2735 121.515Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M33.1272 90.7183C37.6455 92.2463 41.4177 95.9589 42.9014 100.985C45.2405 108.909 41.0195 117.138 33.4525 119.534"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M26.3794 119.632C20.8318 118.455 16.0976 114.372 14.3895 108.591C12.1038 100.852 16.0471 92.7695 23.3083 89.6274L35.7273 89.4715C40.0745 91.2304 43.6 94.8679 45.0219 99.6854C47.5012 108.079 42.652 116.877 34.1932 119.337C33.4668 119.548 32.7404 119.704 32.0111 119.813"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M25.0023 89.6051L23.1597 90.8491V94.5033C18.1449 97.0554 15.5394 103.039 17.2475 108.822C18.3553 112.577 21.0393 115.429 24.3208 116.821C26.7328 117.845 29.4701 118.079 32.1401 117.302C38.4422 115.471 41.9901 108.705 40.0661 102.187C39.5192 100.337 38.588 98.7058 37.3932 97.3588C36.1985 96.0146 34.7372 94.9542 33.1274 94.2473V90.7155V90.7128L34.956 89.4771L25.0023 89.6051V89.6051Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M24.3208 116.824L26.8955 120.333H31.6662L34.2212 116.473"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M71.6126 45.0868H69.8709L66.152 38.7219C65.9921 38.4492 65.7229 38.2933 65.4284 38.2933H65.4087C65.1114 38.3017 64.8338 38.477 64.6851 38.7609L62.0852 43.7871C61.6758 44.5775 60.8792 45.0674 60.0014 45.0674C59.1235 45.0674 58.327 44.5803 57.9175 43.7871L55.3148 38.7581C55.1718 38.4798 54.8941 38.2961 54.5968 38.2906C54.3023 38.2794 54.0163 38.4436 53.8536 38.7247L50.1318 45.0896H48.3845L52.5466 37.9733C52.9869 37.2246 53.7919 36.771 54.6333 36.7988C55.4831 36.8183 56.2572 37.3109 56.6526 38.079L59.2553 43.1025C59.4348 43.4504 59.7546 43.5701 59.9986 43.5701C60.2426 43.5701 60.5623 43.4476 60.7418 43.1025L63.3417 38.079C63.7428 37.3109 64.5169 36.8183 65.3667 36.7988C66.2165 36.7766 67.013 37.2274 67.4533 37.9761L71.607 45.0868H71.6126Z"
                    fill={fill}
                />
                <path
                    d="M65.9527 35.385H64.2111L60.7221 29.4181C60.5089 29.0479 60.1471 29.0034 60.0041 29.0034C59.861 29.0034 59.4992 29.0479 59.2805 29.4181L55.7971 35.385H54.0498L57.9735 28.6666C58.397 27.943 59.1571 27.5089 60.0013 27.5089C60.8455 27.5089 61.5999 27.943 62.0262 28.6666L65.9499 35.385H65.9527Z"
                    fill={fill}
                />
            </svg>
        </SIconSpan>
    )
}

export default AuraIcon
